module.exports = __webpack_public_path__ + "img/12_klio_01.40a6bea4.jpg";